module.exports = __webpack_public_path__ + "static/media/img4.0cce8f39.jpg";